export default database => (payload, context) => {
    const { namespace, relation } = context;
    const db = database.relationDb(namespace, relation);
    return db.count(payload).then(result => {
        return database.processSuccess([result], payload, context);
    });
};
